var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"inventory-header"},_vm._l((_vm.links),function(link){return _c('RouterLink',{key:link.label,staticClass:"inventory-header__link",attrs:{"active-class":"inventory-header__link_active","to":link.to}},[_vm._v(" "+_vm._s(link.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }